// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1ACKB","paramInput":"JobSimulator_paramInput__7kBpx","input":"JobSimulator_input__a9mh-"};